import React from 'react';
import PropTypes from 'prop-types';
import {
  IonModal,
  IonContent,
  IonList,
  IonItem,
  IonIcon,
  IonLabel,
  IonButton,
  IonText,
} from '@ionic/react';
import { closeCircleOutline } from 'ionicons/icons';

function LoyaltyOptOutConfirmModal({ isOpen, onOptOutAction, setShowAlert }) {

  return (
    <IonModal isOpen={isOpen} className="custom-loyalty-alert">
      <IonContent>
        <IonList>
          <IonItem lines="none" className="mt-2x">
            <div className="d-flex-content d-flex-center">
              <IonIcon
                className="loyalty-close-icon"
                icon={closeCircleOutline}
              />
            </div>
          </IonItem>

          <IonItem lines="none">
            <div className="d-flex-content d-flex-center">
              <IonLabel className="ion-text-wrap">
                <h3>Are you sure?</h3>
              </IonLabel>
            </div>
          </IonItem>

          <IonItem lines="none">
            <div className="d-flex-content d-flex-center">
              <IonLabel className="ion-text-wrap">
                <p className="custom-alert-message">By opting out of the program, you will lose all coins and no longer receive exclusive offers.</p>
              </IonLabel>
            </div>
          </IonItem>

          <IonItem lines="none" className="mt-5x">
            <div className="d-flex-row-center">
              <IonButton
                color="medium"
                expand="block"
                fill="solid"
                type="button"
                onClick={() => setShowAlert(false)}
                className="loyalty-button-wrap mr-1"
              >
                <IonText color="light"><p className="loyalty-button-size">CANCEL</p></IonText>
              </IonButton>

              <IonButton
                color="danger"
                expand="block"
                fill="solid"
                type="button"
                onClick={onOptOutAction}
                className="loyalty-button-wrap"
              >
                <IonText color="light"><p className="loyalty-button-size">OPT OUT</p></IonText>
              </IonButton>
            </div>
          </IonItem>
        </IonList>
      </IonContent>
    </IonModal>
  );
}

LoyaltyOptOutConfirmModal.propTypes = {
  isOpen: PropTypes.bool,
  onOptOutAction: PropTypes.func,
  setShowAlert: PropTypes.func,
};

export default LoyaltyOptOutConfirmModal;
